$(function () {
  'use strict';

  if ($('.appointment-page-body-screen').length > 0) {
    const dir = $('html').attr('dir');

    $.validator.addMethod("emailPattern", function (value, element) { // new method for email validation
      return this.optional(element) || /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    });
    $.validator.addMethod("numberPattern", function (value, element) {
      return this.optional(element) || /^[\d\u0660-\u0669\u06F0-\u06F9]{8}$/.test(value);
    });
    $.validator.addMethod("exNumbers", function (value, element) {
      return this.optional(element) || /^[\d\u0660-\u0669\u06F0-\u06F9]{1,2}$/.test(value);
    });
    $.validator.addMethod("nameChar", function (value, element) {
      return this.optional(element) || /^[a-zA-Z\u0600-\u06FF&() -]+$/.test(value);
    });
    $.validator.addMethod("idnumberPattern", function (value, element) {
      return this.optional(element) || /^[0-9]+$/.test(value);
    });

    if (dir == 'ltr') {
      $('label[for="appointment-date"]').append('<span class="visually-hidden">Enter date in the format MM/DD/YYYY</span>');
    } else {
      $('label[for="appointment-date"]').append('<span class="visually-hidden">أدخل التاريخ بالتنسيق MM/DD/YYYY</span>');
    }

    const messagesError = {
      first_name: {
        en: 'Please provide your first name',
        ar: 'رجاء كتابة اسمك الأول'
      },
      last_name: {
        en: 'Please provide your last name',
        ar: 'رجاء كتابة اسمك الأخير'
      },
      number: {
        required: {
          en: 'Please provide your number without country code',
          ar: "يرجى تقديم رقمك بدون رمز البلد"
        },
        numberPattern: {
          en: 'Please enter a valid number',
          ar: "رجاء إدخال رقم هاتف صحيح"
        }
      },
      id_number: {
        required: {
          en: 'Please provide your ID number',
          ar: "رجاء إدخال رقم الهوية الخاصة بك"
        },
        numberPattern: {
          en: 'Please enter a valid ID number',
          ar: 'رجاء ادخال رقم هوية صحيح'
        }
      },
      email: {
        en: 'Please enter a valid email address',
        ar: 'رجاء إدخال عنوان بريد إلكتروني صالح'
      },
      management: {
        en: 'Please select a management',
        ar: "الرجاء اختيار الإدارة"
      },
      reason: {
        en: 'Please provide a reason',
        ar: "الرجاء تحديد السبب"
      },
      date: {
        en: 'Please pick a date',
        ar: "يرجى اختيار تاريخ"
      },
      time: {
        en: 'Please select time',
        ar: "يرجى تحديد الوقت"
      },
    }

    $('#appointment').validate({
      rules: {
        // 'first-name': 'required',
        // 'last-name': 'required',
        'mobile-number': {
          // required: true,
          numberPattern: true
        },
        'personal-id-nmber': {
          // required: true,
          idnumberPattern: true
        },
        'email-address': {
          // required: true,
          emailPattern: true
        },
        // 'management': 'required',
        // 'reason-for-booking': 'required',
        // 'appointment-date': 'required',
        // 'choose-the-appropriate-time': 'required',
      },
      messages: {
        'first-name': dir == 'ltr'? messagesError.first_name.en : messagesError.first_name.ar,
        'last-name': dir == 'ltr'? messagesError.last_name.en : messagesError.last_name.ar,
        'mobile-number': {
          required : dir == 'ltr'? messagesError.number.required.en : messagesError.number.required.ar,
          numberPattern: dir == 'ltr'? messagesError.number.numberPattern.en : messagesError.number.numberPattern.ar
        },
        'personal-id-nmber': {
          required: dir == 'ltr'? messagesError.id_number.required.en : messagesError.id_number.required.ar,
          idnumberPattern: dir == 'ltr'? messagesError.id_number.numberPattern.en : messagesError.id_number.numberPattern.ar
        },
        'email-address': {
          required: dir == 'ltr'? messagesError.email.en : messagesError.email.ar,
          emailPattern: dir == 'ltr'? messagesError.email.en : messagesError.email.ar
        },
        'management': dir == 'ltr'? messagesError.management.en : messagesError.management.ar,
        'reason-for-booking': dir == 'ltr'? messagesError.reason.en : messagesError.reason.ar,
        'appointment-date': dir == 'ltr'? messagesError.date.en : messagesError.date.ar,
        'choose-the-appropriate-time': dir == 'ltr'? messagesError.time.en : messagesError.time.ar,
      },
      errorElement: 'em',
    })
  }
})